export const unfocusActiveElement = () => {
    setTimeout(() => {
        (document.activeElement as HTMLInputElement)?.blur?.();
    }, 0);
};
